import Vue from "vue";
import ElementUI from "element-ui";
import App from "./App.vue";
import router from "./router";
import BaiduMap from 'vue-baidu-map'
import "element-ui/lib/theme-chalk/index.css";
import 'animate.css';
import './styles/global.less'
import './assets/icons' // icon

import { Message } from 'element-ui';
Vue.prototype.$message = Message;  // 通过原型链全局注册
// qiankun的配置---------------------------------------------------------------------------------
import { registerMicroApps, start } from 'qiankun';
import microApps from './micro-app';
import loadingDirective from './directives/loading';  // 引入自定义指令

Vue.directive('loading', loadingDirective);  // 注册指令
//传递数据
// import { initGlobalState } from 'qiankun';
registerMicroApps(microApps, {
  beforeLoad: app => {
    console.log('before load app.name====>>>>>', app.name)
  },
  beforeMount: [
    app => {
      console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name);
    },
  ],
  afterMount: [
    app => {
      console.log('[LifeCycle] after mount %c%s', 'color: green;', app.name);
    }
  ],
  afterUnmount: [
    app => {
      console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name);
    },
  ],
});
start();

// qiankun的配置---------------------------------------------------------------------------------



Vue.config.productionTip = false;

/**
 * 配置全局loading提示框
 * 显示loading this.showLoading()
 * 关闭loading this.hideLoading()
 */
Vue.prototype.loading = null
Vue.prototype.showLoading = function (msg = 'Loading') {
  Vue.prototype.loading = this.$loading({
    lock: true,
    text: msg,
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
}
Vue.prototype.hideLoading = function () {
  Vue.prototype.loading.close();
}

Vue.prototype.msgsuccess = function (msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "success"
  });
}

Vue.prototype.msgerror = function (msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "error"
  });
}

Vue.prototype.msginfo = function (msg) {
  this.$message.info(msg);
}

//全局修改弹窗黑幕点击关闭弹窗默认组件的配置
ElementUI.Dialog.props.appendToBody.default = true




//设置ElementUI组件的默认大小
Vue.use(ElementUI, {
  size: 'mini'
})

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'K41uUmX1jaPXO6pnczAePzI0LlPcPGUZ'
})

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
